import React, { useState, useEffect } from 'react';

const FinancialYearFilter = ({ 
  selectedFinancialYear,
  onFinancialYearChange,
  financialYearLoading
}) => {
  const [availableYears, setAvailableYears] = useState([]);

  // Generate years from 2021-2022 to 2025-2026
  const generateYearOptions = () => {
    const years = [];
    for (let startYear = 2023; startYear <= 2026; startYear++) {
      years.push(`${startYear}-${startYear + 1}`);
    }
    return years;
  };

  // Fetch available financial years
  useEffect(() => {
    const years = generateYearOptions();
    setAvailableYears(years);
  }, []);

  const handleYearChange = (event) => {
    const newYear = event.target.value;
    console.log("🎯 Financial Year Changed:", newYear);
    
    if (onFinancialYearChange) {
      onFinancialYearChange(newYear);
    }
  };

  return (
    <div className="col-md-12 mb-1">
      {financialYearLoading ? (
        <div className="text-center">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <small className="d-block mt-1">Loading Financial Year Data...</small>
        </div>
      ) : (
        <select
          id="financialYear"
          className="form-select"
          value={selectedFinancialYear}
          onChange={handleYearChange}
          disabled={financialYearLoading}
        >
          <option value="ALL">All</option>
          {availableYears.map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default FinancialYearFilter;